// this file is automatically generated by git-version script
export const version = {
  name: 'amg-provider-client',
  version: '1.61.0',
  commit: '4a8d0ad3599f7f03f4eb3014943a3a083c33f9a2',
  branch: 'platinum',
  dateGenerated: '2026-03-16T15:21:16.112Z',
};